import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Lab Environment <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Lab Architecture:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "67.0138888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAABJ0AAASdAHeZh94AAACp0lEQVQozy2SzW/ScBjHe9Kb+wf06s140XDx7tmTelg86w4eTYzxZuLJGLO4xHjCjTF5CTMEGODYYOVtMqhQOtrSMvpCW9r+3lpgM4ph7JMnefI8yfd5nuT5UhhjhBBeJs/3z9pKIcSmg3Ih3E0Hu5kgn90U8iE+tzmu/5hhdz6f/7vE930KY0IIwUs18TxNUI/3usVkv5rh6ZRYTvN0qpWLsQeJP0Omy5yEtrfj8XgsFpMkiYIQ8Twvy4MrhkNFG2kjQ9F1VR+pI2NkWqIkcz2hI4jP19Yoirp2/TpFUdFolHIcpy9JlmWpqqpdoRq6aZu2bTmaonMcpw6H+aPSrcCDm3fu374XuBsIrKzcSCaTlOsCQRD6fdEwRrp+pe7KrXLjsNIotno1Xug1Wwz9q/H+89dwNPnw8eqj1Wc9jlNVbSHmBV6UBg7Etgtmk3PR6MSZ9e2DT5HKl6zwzQDDeqOlu+7f+YJMoRiKJebzOcaEwgiWG+3XO5030e67OKuaWoEPR0pb4dL3mpzZFyMdsVEo0FqVw8CDnj85v7iYzQAACCFqgsGHaPXJBvN0o/lx9zd7Wi9L+Z+mE1ENmq+uJ97mS2nkgr4OWBX1RqQi2LYLCFl8lgIAvtpqvgiyL7c6ojK2oXLUT+dEOX4qVgZ0UYzptpVtqg3RnF4sDpcs33KgtxRjjGVtXGf6O7tHrgttaNX6uZMu3WDLFT6r2RLGU6aj8GfjFGPu1Eb7rAkgIpeeohbJ8w4rnWjiYGkYALEFgIOAA6ADFuaZ+d7QBPFjNVxV9xgdYbQ0JDX1SftsnGhqJd7Sx3DiEd0GTXm819bpnsEpNkIYIjT1SWdopxhtYLgTj6CrzcRzIbZcZDgQLiYSjIlHiGIBGyDfI8sOxgQiDC5jWSKE/wN3zYgvY0J33wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "env",
        "title": "env",
        "src": "/Instana-1-Day-Partner-Workshop/static/5d150e775856854579a62e772570eccb/3cbba/env.1.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/5d150e775856854579a62e772570eccb/7fc1e/env.1.png 288w", "/Instana-1-Day-Partner-Workshop/static/5d150e775856854579a62e772570eccb/a5df1/env.1.png 576w", "/Instana-1-Day-Partner-Workshop/static/5d150e775856854579a62e772570eccb/3cbba/env.1.png 1152w", "/Instana-1-Day-Partner-Workshop/static/5d150e775856854579a62e772570eccb/0b124/env.1.png 1728w", "/Instana-1-Day-Partner-Workshop/static/5d150e775856854579a62e772570eccb/e927a/env.1.png 1766w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You will have access to both the Instana Demo and Sandbox instances. `}</p>
    <p>{`For the labs we will be utilizing the Sandbox instance.
`}<a parentName="p" {...{
        "href": "https://sandbox-partner.instana.io"
      }}>{`https://sandbox-partner.instana.io`}</a>{` `}</p>
    <p>{`The Instana Demo can be used for client demonstrations at a later date or for learning purposes.
`}<a parentName="p" {...{
        "href": "https://demo-partner.instana.io/"
      }}>{`https://demo-partner.instana.io/`}</a></p>
    <h2>{`Stan’s Robot Shop App - Sample Microservices Application:`}</h2>
    <p>{`Stan’s Robot Shop is a sample microservice application we use in the sandbox environment to test and learn containerized application orchestration and monitoring techniques.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/instana/robot-shop"
      }}>{`https://github.com/instana/robot-shop`}</a></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "649px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "72.56944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAA7DAAAOwwHHb6hkAAADEElEQVQozz3Ny2/aBgDHcV82rWDjF6Q8DX7b2Ni8jDF+gDEYDC6PFJY0hCRt0yxNlkhRyrImqnbZDpN22p8w7bjjTu1t2h82LUiRPsffVz8g0najmh7puM+GQbRlRF0v4vbAHAHGE1Ay9TWC6k7n46efbjZ3Vze3B8evhXINSqVrtpOiGQAUihBJgyQF8mKUyEezuQjLgTvPQTwO4olnKJah6KpplY2Wqhu8UqbVCoTH73/+Re8PgMh8FywpUDwRwxNpTsmpek6qpCt6tqqnao2M3oqrVSSZwZ6n0GTmGywOZrLT4ze///EnbzkA6HZjJB1LpuFUVnDG8uRQCve5bsj3J/xwyg4npB9yjsdaHcZy4HQuXZT//uffvz5/+eHX34DodAYOAojh4FRWNgPVnRetkay5Rd0tGl1Ws9mGzVsuaXaopoUSBaxAr69vgtVRa/QCgLRmdDaHSiqcJhRjrA4PpfFKmq3F4UIcL9lwIXT8YtuX+iNKt7ACHU1moGw+wfBf4TsATFDQIIDaLpImjHqgLc8rzlzX/JrqlFVbqdhK3a4YHaXhUIqGkyxMkDBBxnIFNE8BMVmN2Z2YVEJzpGNMjcWloY1NxdM1X612K82eavRF3eUbbbbh4IwQI0g4T20BCMMjFI/kaSRPe9ZL92TTnL1zOwvTCA07tHqzUmsgm75sD4SWhzMiXKARktkCEJJFKA6hebTAdlsv/YtP9vJi6O2PB3uuO9fNsWIMynYg6B5Vb8c5Cd7uHz0+M8L/McXbzoF/tOnPvwsmb6ZH37eXp/XJuj4/Ekd7BX+X6012RAV+fNoCUFbcwthiY3ZhHj8YJ3ets3vz6qFx+bF6/SBf3wvnt9T7W3p9lhBVhBGeEgDlpC2MkxvBO3t157z9sXmy0d5+qJ9+KJ9vlL0zdfGam67I8Nu4VEHY4lMCYEJpC+cVs33Yn1650/fN8am6e17av9QGr+ruXHFe0HqPaXR35CrKy08JgInqFi6WDXvp9o5Nb1XzDkrdvVK4VqxQskPeGolOQOpdvFh92mOi+h9xEbfXZF/FdQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "env",
        "title": "env",
        "src": "/Instana-1-Day-Partner-Workshop/static/86788184f1d7241510b43542fcb33500/7418f/env.2.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/86788184f1d7241510b43542fcb33500/7fc1e/env.2.png 288w", "/Instana-1-Day-Partner-Workshop/static/86788184f1d7241510b43542fcb33500/a5df1/env.2.png 576w", "/Instana-1-Day-Partner-Workshop/static/86788184f1d7241510b43542fcb33500/7418f/env.2.png 649w"],
        "sizes": "(max-width: 649px) 100vw, 649px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      